export default __webpack_public_path__ + "static/media/gallery-wip-flash-suppressor_02.14cd74b0.jpg";